import { useEffect } from 'react'
import { useCookies } from 'react-cookie'

import {
  FIRST_TOUCH_URL_COOKIE,
  LANDING_PAGE_COOKIE,
  LeadSources,
  MARKETING_ATTRIBUTION_COOKIE,
  MARKETING_ATTRIBUTION_COOKIE_EXPIRATION_TIME,
  MARKETING_ONBOUNCE_LANDING_PAGE_DOMAIN
} from '@app/constants'
import { detectLeadSourceByURL } from '@app/utils/analytics'
import { getCurrentUrl } from '@app/utils/urlUtils'

export interface MarketingAttribution {
  firstTouchUrl: string
  leadSource: LeadSources
  creationDate: string
}

export const useMarketingAttribution = () => {
  const [cookies, setCookie, removeCookie] = useCookies([
    MARKETING_ATTRIBUTION_COOKIE,
    LANDING_PAGE_COOKIE,
    FIRST_TOUCH_URL_COOKIE
  ])

  useEffect(() => {
    // NOTE: added 1 second to wait before defining marketing attribution
    //       this will give more chance for Google Optimize to do a redirection for A/B testing
    setTimeout(handleMarketingAttribution, 1000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleMarketingAttribution = () => {
    const marketingAttribution = cookies[MARKETING_ATTRIBUTION_COOKIE]

    if (cookies[FIRST_TOUCH_URL_COOKIE] && marketingAttribution) {
      // NOTE: a temp code to migrate old separate cookie for first touch cookie into single cookie
      //       remove in 90 days
      marketingAttribution.firstTouchUrl = cookies[FIRST_TOUCH_URL_COOKIE]
      removeCookie(FIRST_TOUCH_URL_COOKIE)
      const expirationDate = new Date(new Date().getTime() + MARKETING_ATTRIBUTION_COOKIE_EXPIRATION_TIME)
      setCookie(MARKETING_ATTRIBUTION_COOKIE, JSON.stringify(marketingAttribution), {
        domain: window.location.hostname,
        path: '/',
        expires: expirationDate
      })
    }

    if (!marketingAttribution) {
      const currUrl = getCurrentUrl()
      // NOTE: give Landing Page URL more priority than our current URL
      //       since it can contain landing page URL with UTM attributes we need to define lead source correctly
      const url = cookies[LANDING_PAGE_COOKIE] ? String(cookies[LANDING_PAGE_COOKIE]) : currUrl
      const expirationDate = new Date(new Date().getTime() + MARKETING_ATTRIBUTION_COOKIE_EXPIRATION_TIME)
      // NOTE: we want to consider our onbounce landing page as First Touch URL
      const firstTouchUrl = url.includes(MARKETING_ONBOUNCE_LANDING_PAGE_DOMAIN) ? url : currUrl
      const marketingAttribution: MarketingAttribution = {
        firstTouchUrl,
        leadSource: detectLeadSourceByURL(url, document.referrer),
        creationDate: new Date().toISOString()
      }
      setCookie(MARKETING_ATTRIBUTION_COOKIE, JSON.stringify(marketingAttribution), {
        domain: window.location.hostname,
        path: '/',
        expires: expirationDate
      })
    }
  }
}
